import { Grid } from '@mui/material';
import * as React from 'react';
import { blogService } from '../../_mocks_/BlogService';
import BlogDetails from './BlogDetails';


export default function BlogSection() {
    const [data] = React.useState(blogService)
    
    return (

        <Grid container spacing={2}>
            {data.map((step, index) => (

                <Grid item sm={12} md={6} lg={4} key={step.id}>

                    <BlogDetails item={step} key={step.id} />

                </Grid>
            ))}
        </Grid>
    )
}
